import EventEmitter from "events";

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

export default new EventEmitter();